module.exports = __webpack_public_path__ + "img/10.63464807.svg";